import { getChannelRules } from '../../services/api/channelRule.api';
import { getReSyncAllocation, postReSyncAllocation } from '../../services/api/allocation.api';
import {
	GET_CHANNEL_RULE_LIST_REQUEST,
	GET_CHANNEL_RULE_LIST_SUCCESS,
	GET_CHANNEL_RULE_LIST_FAILURE,
	GET_ALLOCATION_CHANNEL_RULE_LIST_REQUEST,
	GET_ALLOCATION_CHANNEL_RULE_LIST_SUCCESS,
	GET_ALLOCATION_CHANNEL_RULE_LIST_FAILURE,
	POST_ALLOCATION_CHANNEL_RULE_LIST_REQUEST,
	POST_ALLOCATION_CHANNEL_RULE_LIST_SUCCESS,
	POST_ALLOCATION_CHANNEL_RULE_LIST_FAILURE,
} from '../types';
import { transformChannelRoles, transformAllocationChannel } from '../../transforms/allocation';
import { transformPagination } from '../../transforms/pagination';
import { transformError } from '../../transforms/error';
import { mapTable } from '../../helpers/table';
import { ENV } from '../../enums/endpoint';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: transformChannelRoles([]),
		pagination: transformPagination({}),
		status: {},
	},

	getters: {
		tableData: (state) => mapTable(state.data, {
			// left side is transform keys, right side is table field keys
			id: 'id',
			name: 'channel_rule_name',
			priority: 'priority',
			totalProducts: 'total_sku',
			totalConditions: 'conditions',
			createdAt: 'created_at',
			isActive: 'status',
		}),
		channelRuleOptions: (state) => {
			//* hide for fix value is caseclub
			// const rule = {
			// 	name: 'All stock rules',
			// 	value: null,
			// };
			const rules = state.data.map((item) => {
				return {
					name: item.name,
					value: item.id,
				};
			});
			return rules;
			// return [rule, ...rules];
		},
	},

	mutations: {
		[GET_CHANNEL_RULE_LIST_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = [];
		},
		[GET_CHANNEL_RULE_LIST_SUCCESS](state, { data, meta }) {
			state.isLoading = false;
			let channelsRuleItems = data;
			if (process.env.VUE_APP_NODE_ENV === ENV.DEV || process.env.VUE_APP_NODE_ENV === ENV.DEVELOPMENT) {
				channelsRuleItems = channelsRuleItems.filter((item) => item.id === 106); // case caseclub on dev
			} else {
				channelsRuleItems = channelsRuleItems.filter((item) => item.id === 485); // case caseclub on prd
			}
			state.data = transformChannelRoles(channelsRuleItems);
			state.pagination = transformPagination(meta);
		},
		[GET_CHANNEL_RULE_LIST_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
		[GET_ALLOCATION_CHANNEL_RULE_LIST_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = [];
		},
		[GET_ALLOCATION_CHANNEL_RULE_LIST_SUCCESS](state, data) {
			state.isLoading = false;
			state.status = transformAllocationChannel(data);
		},
		[GET_ALLOCATION_CHANNEL_RULE_LIST_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
		[POST_ALLOCATION_CHANNEL_RULE_LIST_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = [];
		},
		[POST_ALLOCATION_CHANNEL_RULE_LIST_SUCCESS](state, data) {
			state.isLoading = false;
			state.status = transformAllocationChannel(data);
		},
		[POST_ALLOCATION_CHANNEL_RULE_LIST_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async getChannelRules({ commit }, params = {}) {
			try {
				commit(GET_CHANNEL_RULE_LIST_REQUEST);
				const { data } = await getChannelRules({
					...params,
					per_page: params.perPage || 30,
				});
				commit(GET_CHANNEL_RULE_LIST_SUCCESS, data);
			} catch (error) {
				commit(GET_CHANNEL_RULE_LIST_FAILURE, error);
			}
		},
		async getReSyncAllocationChannels({ commit }) {
			try {
				commit(GET_ALLOCATION_CHANNEL_RULE_LIST_REQUEST);
				const { data } = await getReSyncAllocation();
				commit(GET_ALLOCATION_CHANNEL_RULE_LIST_SUCCESS, data);
			} catch (error) {
				commit(GET_ALLOCATION_CHANNEL_RULE_LIST_FAILURE, error);
			}
		},
		async postReSyncAllocationChannels({ commit }) {
			try {
				commit(POST_ALLOCATION_CHANNEL_RULE_LIST_REQUEST);
				const { data } = await postReSyncAllocation();
				commit(POST_ALLOCATION_CHANNEL_RULE_LIST_SUCCESS, data);
			} catch (error) {
				commit(POST_ALLOCATION_CHANNEL_RULE_LIST_FAILURE, error);
			}
		},
	},
};
